export default "__VITE_ASSET__5ef06b3a__"